import React, { useState, useEffect } from 'react';
import { Shield, Zap, User, Bot } from 'lucide-react';
import { CitizenProvider } from './contexts/CitizenContext';
import CitizenPortalPages from './components/CitizenPortalPages';
import StaffDashboard from './components/StaffDashboard';
import AgentMonitoringDashboard from './components/AgentMonitoringDashboard';
import { initialCitizens, initialCitizenNotifications } from './data/citizensData';
import { runPredictiveEngine } from './utils/predictiveEngine';

function App() {
  const [activeTab, setActiveTab] = useState('citizen');
  
  // ===== Monitoring State =====
  const [citizens, setCitizens] = useState(initialCitizens);
  const [notifications, setNotifications] = useState([]);
  const [systemStats, setSystemStats] = useState({
    proactiveAlerts: 0,
    preventedComplaints: 0,
    autoActions: 0
  });

  // ===== Citizen Portal State =====
  const [selectedCitizen] = useState(initialCitizens[1]); // فاطمة علي كمثال
  const [citizenNotifications, setCitizenNotifications] = useState(initialCitizenNotifications);
  // حساب عدد الإشعارات غير المقروءة
  const unreadCount = citizenNotifications.filter(notif => !notif.read).length;
  
  // دالة لتحديد الإشعارات كمقروءة
  const markAsRead = (notificationId) => {
    setCitizenNotifications(prev => 
      prev.map(notif => 
        notif.id === notificationId ? { ...notif, read: true } : notif
      )
    );
  };

  // ===== Monitoring Logic =====
  useEffect(() => {
    const interval = setInterval(() => {
      runPredictiveEngine(citizens, setNotifications, setSystemStats, setCitizens);
    }, 3000);
    return () => clearInterval(interval);
  }, [citizens]);


  return (
    <CitizenProvider>
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-blue-50 to-purple-50 p-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Zap className="w-14 h-14 text-indigo-600" />
              <h1 className="text-5xl font-bold text-gray-800">سبق</h1>
            </div>
            <p className="text-xl text-gray-600">النظام الاستباقي للخدمات الحكومية الذكية</p>
          </div>

          {/* Navigation Tabs */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <button
              onClick={() => setActiveTab('citizen')}
              className={`flex items-center gap-3 px-6 py-4 rounded-2xl font-bold text-lg transition-all shadow-lg hover:shadow-xl ${
                activeTab === 'citizen' 
                  ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white scale-105' 
                  : 'bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-center justify-center gap-2">
                <User className="w-6 h-6" />
                👤 بوابة المواطن
                <span className="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded-full">عام</span>
              </div>
            </button>


          <button
            onClick={() => setActiveTab('staff')}
            className={`flex items-center gap-3 px-6 py-4 rounded-2xl font-bold text-lg transition-all shadow-lg hover:shadow-xl ${
              activeTab === 'staff' 
                ? 'bg-gradient-to-r from-green-600 to-emerald-600 text-white scale-105' 
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            <div className="flex items-center justify-center gap-2">
              <Shield className="w-6 h-6" />
              👨‍💼 لوحة الموظفين
              <span className="text-xs bg-green-200 text-green-800 px-2 py-1 rounded-full">موظف</span>
            </div>
          </button>


          <button
            onClick={() => setActiveTab('agents')}
            className={`flex items-center gap-3 px-6 py-4 rounded-2xl font-bold text-lg transition-all shadow-lg hover:shadow-xl ${
              activeTab === 'agents' 
                ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white scale-105' 
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            <div className="flex items-center justify-center gap-2">
              <Bot className="w-6 h-6" />
              👨‍💻 مراقبة الوكلاء
              <span className="text-xs bg-purple-200 text-purple-800 px-2 py-1 rounded-full">تقني</span>
            </div>
          </button>

        </div>

        {/* Tab Content */}
        {activeTab === 'citizen' && (
          <CitizenPortalPages
            selectedCitizen={selectedCitizen}
            citizenNotifications={citizenNotifications}
            unreadCount={unreadCount}
            markAsRead={markAsRead}
          />
        )}


        {activeTab === 'staff' && (
          <StaffDashboard />
        )}

        {activeTab === 'agents' && (
          <AgentMonitoringDashboard />
        )}
        
        </div>
      </div>
    </CitizenProvider>
  );
}

export default App;